import {Component, Input, OnInit} from '@angular/core';
import {ReportChartDatasetType, ReportChartOption, ReportChartOptions, ReportChartOptionValue } from 'src/app/shared/classes/chart-report';
import { ReportsChartService } from 'src/app/shared/services/reports-chart.service';
import {ReportStore} from '../../../../../shared/store/report/report.store';
import {AdRequestParams} from '../../../../../shared/interfaces/ad-reports';
import {ReportChartStore} from '../../../../../shared/store/report/report-chart.store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-chart-options',
  templateUrl: './chart-options.component.html',
  styleUrls: ['./chart-options.component.scss']
})
export class ChartOptionsComponent implements OnInit {
  @Input() public params: Partial<AdRequestParams>;
  @Input() public options: ReportChartOptions = [];

  private color: string;

  constructor(
    private readonly _reportsGraphS:     ReportsChartService,
    private readonly _reportStore: ReportStore,
    private readonly _reportChartStore: ReportChartStore
  ) {}

  ngOnInit(): void {}

  public hasFilter(value: string): Observable<boolean> {
    return this._reportStore.hasFilter(this.params.dimensions[0], value);
  }

  public onChartVisibilityChange(metric: ReportChartOption, value: ReportChartOptionValue, visible: boolean): void {
    if (value) {
      value.visible = visible;

      let numberOfHidden: number = 0;

      for (const value of metric.values) {
        if (!value.visible) {
          numberOfHidden++;
        }
      }

      metric.visible = numberOfHidden !== metric.values.length && true || false;
    } else {
      for (const value of metric.values) {
        value.visible = visible;
      }
      metric.visible = visible;
    }

    this._reportChartStore.updateConfig(this._reportsGraphS.getChartConfig());
    this._reportStore.updateRequestParamsSubmitted({ options: this.options });
  }

  public onChartTypeChange(metric: ReportChartOption, value: ReportChartOptionValue, type: ReportChartDatasetType): void {
    if (value) {
      if (type === 'stacked_bar') {
        for (const value of metric.values) {
          value.type = type;
        }
        metric.type = type;
      } else {
        value.type = type;

        let numberOfSameType: number = 0;

        for (const value of metric.values) {
          if (value.type === type) {
            numberOfSameType++;
          }
        }

        metric.type = numberOfSameType === metric.values.length && type || 'mixed';
      }
    } else {
      for (const value of metric.values) {
        value.type = type;
      }
      metric.type = type;
    }

    this._reportChartStore.updateConfig(this._reportsGraphS.getChartConfig());
    this._reportStore.updateRequestParamsSubmitted({ options: this.options });
  };

  public onToggleOpened(option: ReportChartOption): void {
    option.opened = !option.opened;
    this._reportChartStore.updateConfig(this._reportsGraphS.getChartConfig());
    this._reportStore.updateRequestParamsSubmitted({ options: this.options });
  }

  public onColorPickerClosed(opened: boolean, value: ReportChartOptionValue | ReportChartOption): void {
    if (!opened && this.color) {
      value.color = this.color;
      this.color = null;
      this._reportChartStore.updateConfig(this._reportsGraphS.getChartConfig());
      this._reportStore.updateRequestParamsSubmitted({ options: this.options });
    }
  }

  public onColorPickerChange(color: string): void {
    this.color = color;
  }

  public onFilterChange(status, value: ReportChartOptionValue): void {
    if (status) {
      this._reportStore.addFilter({
        slug: this.params.dimensions[0],
        value: value.value
      });
    } else {
      this._reportStore.removeFilter({
        slug: this.params.dimensions[0],
        value: value.value
      });
    }
  }

}
